import { For, If, onMount, reactive, watch } from 'cdui-js';
import { CheckBoxCard } from '../../../../components/CheckBoxCard';
import {
  lastProcess,
  nextProcess,
  pState,
  refreshApplyIfIdentityChanged,
  setFormValidateFunc,
  syncEditRangeAfterIdentityChange,
} from '../../store';
import { busConfigs, busConfigsTick } from '../../../../../../stores/bus-config';
import { LastNextBtns } from '../../components/LastNextBtns';
import { saveUserInfo } from '../../../../../../api/open-account';
import { showToast } from '../../../../components/Toast';
import i18n from '../../../../../../i18n';
import { preloadUploadLicExampleImages } from '../idlePreload';
import { applyNationalityForIdentity } from './taxSync';

export const SelectIDCard = () => {
  const state = reactive({
    loading: false,
    identityType: (busConfigs.identityType || []) as { label: any; value: string }[],
  });

  const syncIdentityType = () => {
    state.identityType = (busConfigs.identityType || []) as { label: any; value: string }[];
  };

  const validateFunc = async () => {
    const selected = pState.uploadLicForm.idCardType;
    if (!selected) {
      showToast(i18n.OpenProgress.Info.SelectId.ToastRequired);
      return false;
    }
    // 字典已加载时，所选值必须在选项内；未加载时仅要求已有选中值
    if (state.identityType.length > 0 && !state.identityType.some((i) => i.value === selected)) {
      showToast(i18n.OpenProgress.Info.SelectId.ToastRequired);
      return false;
    }
    return true;
  };

  watch(
    () => busConfigsTick.v,
    () => {
      syncIdentityType();
    },
  );

  watch(
    () => pState.uploadLicForm.idCardType,
    (t) => {
      preloadUploadLicExampleImages(t);
    },
  );

  onMount(() => {
    setFormValidateFunc({ callback: validateFunc });
    preloadUploadLicExampleImages(pState.uploadLicForm.idCardType);
  });

  return (
    <div class="padding-x-L margin-y-XL">
      <div class="font-s-L font-bold color-D margin-b-L">{i18n.OpenProgress.Info.SelectId.Title}</div>
      <For each={state.identityType}>
        {(item) => (
          <CheckBoxCard
            active={pState.uploadLicForm.idCardType === item.value}
            onclick={() => {
              const prev = pState.uploadLicForm.idCardType;
              pState.uploadLicForm.idCardType = item.value;
              pState.uploadLicForm.identityType = item.value;
              applyNationalityForIdentity(item.value, prev);
            }}
            class="margin-b-S round-XL"
            showBadge={false}
            activeBorderColor="var(--bordercd)"
          >
            <div class="padding-x-L flex flex-column justify-center" style={{ height: '78px' }}>
              <div class="color-D font-s leading-20px">{item.label}</div>
              <If when={item.value === 'HONG_KONG'}>
                <div>{i18n.OpenProgress.Info.SelectId.HkIdHint}</div>
              </If>
            </div>
          </CheckBoxCard>
        )}
      </For>

      <LastNextBtns
        loading={state.loading}
        last={() => {
          lastProcess();
        }}
        next={async () => {
          try {
            state.loading = true;
            const identityType = pState.uploadLicForm.idCardType;
            pState.uploadLicForm.identityType = identityType;
            applyNationalityForIdentity(identityType);
            const data = await saveUserInfo({
              identityType,
              idCardType: identityType,
              nationality: pState.uploadLicForm.nationality,
              progress: 2,
            });
            if (!pState.id) {
              pState.id = data.id;
            }
            // 身份类型与后台不一致时，save 后再拉 getByUserId 对齐附件/后续字段
            await refreshApplyIfIdentityChanged(identityType);
            // 确认页改证件切到大陆时把银联页纳入编辑区间，并校正返回确认页步号
            syncEditRangeAfterIdentityChange(identityType);
          } catch (e) {
            state.loading = false;
          } finally {
            state.loading = false;
          }

          nextProcess();
        }}
      />
    </div>
  );
};
